import adminApi from './adminApi';

const readJson = async (response) => {
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.detail || 'Unable to load release notes.');
  return body;
};

export const getReleaseNotes = async ({
  page = 1,
  perPage = 5,
  search = '',
  fromDate = '',
  toDate = '',
} = {}) => {
  const params = new URLSearchParams({
    page: String(page),
    per_page: String(perPage),
  });
  if (search) params.set('search', search);
  if (fromDate) params.set('from_date', fromDate);
  if (toDate) params.set('to_date', toDate);
  return readJson(await adminApi.get(`/api/admin/release-notes?${params}`));
};

export const markReleaseNoteSeen = async (releaseNoteId) => readJson(
  await adminApi.put('/api/admin/release-notes/seen', { release_note_id: releaseNoteId }),
);
